// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  flex-direction: column;
}
.loader ion-spinner {
  width: 50px;
  height: 50px;
}
.loader h1 {
  margin-top: 32px;
  font-size: 20px;
}

.container {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.container .header-container {
  height: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: var(--ion-color-light);
  flex-grow: 1;
}
.container .header-container img {
  position: absolute;
  filter: invert(1) opacity(0.5);
  height: 100%;
  width: 100%;
  object-fit: cover;
}
.container .header-container h1 {
  font-size: 40px;
  font-weight: 900;
  margin-bottom: 16px;
  z-index: 11;
}
.container .header-container h4 {
  font-size: 20px;
  font-weight: 600;
  z-index: 11;
  color: var(--ion-color-medium);
}
.container .body-container {
  height: fit-content;
  overflow-y: auto;
}
.container .body-container .title {
  color: var(--ion-color-medium);
  font-size: 14px;
  z-index: 11;
  width: 100%;
  font-weight: 600;
  margin-bottom: 10px;
  text-align: left;
}
.container .body-container ion-item {
  --padding-top: 10px;
  --padding-bottom: 10px;
  --padding-start: 10px;
  --padding-end: 10px;
}
.container .body-container ion-item h2 {
  font-weight: 600;
  font-size: 14px;
}
.container .body-container ion-item ion-icon {
  color: var(--ion-color-success);
  font-size: 30px;
}
.container .body-container ion-item .price {
  font-weight: 600;
  font-size: 16px;
}

ion-footer {
  border-top: 1px solid #f4f5f8;
}

.close-button {
  background: #d9dbdf;
  border-radius: 50px;
  padding: 0;
  --padding-start: 0;
  --padding-end: 0;
  margin-right: 8px;
  width: 30px;
  height: 30px;
  max-width: 30px;
  max-height: 30px;
}
.close-button ion-icon {
  font-size: 20px;
}

ion-header {
  position: fixed;
}
ion-header ion-toolbar {
  --background: transparent;
  --border-width: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/payments/payment-success/payment-success.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,sBAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;AACJ;AAEE;EACE,gBAAA;EACA,eAAA;AAAJ;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AADF;AAGE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,kCAAA;EACA,YAAA;AADJ;AAGI;EACE,kBAAA;EACA,8BAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;AADN;AAII;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AAFN;AAKI;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,8BAAA;AAHN;AAOE;EACE,mBAAA;EACA,gBAAA;AALJ;AAOI;EACE,8BAAA;EACA,eAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AALN;AAQI;EACE,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;AANN;AAQM;EACE,gBAAA;EACA,eAAA;AANR;AASM;EACE,+BAAA;EACA,eAAA;AAPR;AAUM;EACE,gBAAA;EACA,eAAA;AARR;;AAcA;EACE,6BAAA;AAXF;;AAcA;EACE,mBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAXF;AAaE;EACE,eAAA;AAXJ;;AAeA;EACE,eAAA;AAZF;AAcE;EACE,yBAAA;EACA,4BAAA;AAZJ","sourcesContent":[".loader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  flex-direction: column;\n\n  ion-spinner {\n    width: 50px;\n    height: 50px;\n  }\n\n  h1 {\n    margin-top: 32px;\n    font-size: 20px;\n  }\n}\n\n.container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n\n  .header-container {\n    height: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    background: var(--ion-color-light);\n    flex-grow: 1;\n\n    img {\n      position: absolute;\n      filter: invert(1) opacity(0.5);\n      height: 100%;\n      width: 100%;\n      object-fit: cover;\n    }\n\n    h1 {\n      font-size: 40px;\n      font-weight: 900;\n      margin-bottom: 16px;\n      z-index: 11;\n    }\n\n    h4 {\n      font-size: 20px;\n      font-weight: 600;\n      z-index: 11;\n      color: var(--ion-color-medium);\n    }\n  }\n\n  .body-container {\n    height: fit-content;\n    overflow-y: auto;\n\n    .title {\n      color: var(--ion-color-medium);\n      font-size: 14px;\n      z-index: 11;\n      width: 100%;\n      font-weight: 600;\n      margin-bottom: 10px;\n      text-align: left;\n    }\n\n    ion-item {\n      --padding-top: 10px;\n      --padding-bottom: 10px;\n      --padding-start: 10px;\n      --padding-end: 10px;\n\n      h2 {\n        font-weight: 600;\n        font-size: 14px;\n      }\n\n      ion-icon {\n        color: var(--ion-color-success);\n        font-size: 30px;\n      }\n\n      .price {\n        font-weight: 600;\n        font-size: 16px;\n      }\n    }\n  }\n}\n\nion-footer {\n  border-top: 1px solid #f4f5f8;\n}\n\n.close-button {\n  background: #d9dbdf;\n  border-radius: 50px;\n  padding: 0;\n  --padding-start: 0;\n  --padding-end: 0;\n  margin-right: 8px;\n  width: 30px;\n  height: 30px;\n  max-width: 30px;\n  max-height: 30px;\n\n  ion-icon {\n    font-size: 20px;\n  }\n}\n\nion-header {\n  position: fixed;\n\n  ion-toolbar {\n    --background: transparent;\n    --border-width: 0 !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
